<template>
  <main>
    <div class="certified-courses">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/attestations">{{ $t("attestation") }}</router-link>
          </li>
        </ul>
        <div class="page-sub-title jcc certified-sub-title">
          <h1>
            <i class="fa-title"></i><i>{{ $t("attestation") }}</i>
          </h1>
        </div>
        <div class="certified-courses-title">
          <p>{{ $t("attestation_description") }}</p>
        </div>

        <attestation-lang-switch @change="load" />
        <p class="att-notice">{{ $t("attestation_one_attempt") }}</p>

        <p class="empty" v-if="attestations && attestations.count === 0">
          {{ $t("attestation_empty") }}
        </p>

        <div class="att-grid" v-if="attestations">
          <article
            class="att-card"
            v-for="item in attestations.results"
            :key="item.id"
          >
            <span class="att-status" :class="`att-status--${item.result || 'new'}`">
              {{ resultLabel(item) }}
            </span>
            <h3 class="att-card__title">{{ item.name }}</h3>
            <div
              class="att-card__text"
              v-if="item.description"
              v-html="$processHtml(item.description)"
            ></div>
            <ul class="att-card__meta" v-if="item.quiz_slug">
              <li>{{ $t("attestation_questions", { n: item.questions_count }) }}</li>
              <li>{{ $t("attestation_minutes", { n: item.duration }) }}</li>
            </ul>

            <div class="att-card__footer">
              <p class="att-score" v-if="item.is_finished">
                <strong>{{ item.score }}%</strong>
                <span>{{ $t("your_score") }}</span>
              </p>
              <button
                v-else-if="item.quiz_slug"
                class="att-start"
                @click.prevent="$router.push(`/attestation-test/${item.quiz_slug}`)"
              >
                {{ $t("start_test") }}
              </button>
              <p class="empty" v-else>{{ $t("attestation_no_quiz") }}</p>
            </div>
          </article>
        </div>

        <loading v-if="!attestations" />
      </div>
    </div>
  </main>
</template>

<script>
import AttestationLangSwitch from "@/components/AttestationLangSwitch";
import Loading from "@/components/loading";

export default {
  name: "Attestations",
  components: { AttestationLangSwitch, Loading },
  async mounted() {
    await this.load();
  },
  methods: {
    load() {
      return this.$store.dispatch("getAttestations");
    },
    resultLabel(item) {
      if (!item.is_finished) return this.$t("attestation_not_started");
      return this.$t(`attestation_result_${item.result}`);
    },
  },
  computed: {
    attestations() {
      return this.$store.getters.getAttestations;
    },
  },
};
</script>

<style scoped>
.att-notice {
  max-width: 640px;
  margin: 0 auto 28px;
  padding: 12px 16px;
  border-left: 4px solid #bd282b;
  border-radius: 0 8px 8px 0;
  background: #fff;
  color: #333;
  font-size: 15px;
  line-height: 21px;
}
.att-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}
@media (max-width: 640px) {
  .att-grid {
    grid-template-columns: 1fr;
  }
}
.att-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 0 30px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(17, 30, 108, 0.06);
}
.att-status {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}
.att-status--new {
  background: #f4f6f8;
  color: #727272;
}
.att-status--passed {
  background: #e6f3d6;
  color: #3f6b08;
}
.att-status--conditional {
  background: #fff1cc;
  color: #7f5f00;
}
.att-status--failed {
  background: #fde3e3;
  color: #bd282b;
}
.att-card__title {
  margin: 12px 0 8px;
  color: #333;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  overflow-wrap: anywhere;
}
.att-card__text {
  margin-bottom: 8px;
  color: #646464;
  font-size: 14px;
}
.att-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin: 0 0 16px;
  padding: 0;
  list-style: none;
  color: #727272;
  font-size: 14px;
  line-height: 20px;
}
.att-card__footer {
  width: 100%;
  margin-top: auto;
}
.att-start {
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 8px;
  background: #bd282b;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}
.att-start:hover,
.att-start:focus-visible {
  background: #9c1f22;
}
.att-score {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 0;
  color: #727272;
  font-size: 14px;
}
.att-score strong {
  color: #333;
  font-size: 28px;
  line-height: 34px;
}
</style>
